module.exports = __webpack_public_path__ + "img/85.66ced3fd.jpg";